import React from "react";
import { Typography, Tooltip, Box } from "@mui/material";
import refresh from "./../../src/pages/home components/assets/refresh.png";

const CaptchaDisplay = ({ captcha, generateCaptcha }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "space-between",
      my: 4,
    }}
  >
    <Typography
      variant="body2"
      sx={{
        color: "#1E1E1E",
        marginRight: "16px",
      }}
    >
      Type the captcha above:
    </Typography>
    <Typography
      variant="h4"
      component="strong"
      sx={{
        color: "#107DE2",
        padding: "5px",
        userSelect: "none",
      }}
    >
      {captcha}
    </Typography>
    <Tooltip title="Refresh Captcha">
      <img
        src={refresh}
        alt="Refresh Captcha"
        onClick={generateCaptcha}
        style={{
          cursor: "pointer",
          paddingLeft: "5px",
          width: "35px",
          height: "auto",
        }}
      />
    </Tooltip>
  </Box>
);

export default CaptchaDisplay;
